import { FC, PropsWithChildren, useEffect, useState } from 'react';

export type TTakeoverStatusProps = {
  when: 'active' | 'inactive';
  fallback?: any;
};

// only show the children when we are on a specific set of paths
const TakeoverStatus: FC<PropsWithChildren<TTakeoverStatusProps>> = (props) => {
  const [status, setStatus] = useState<'active' | 'inactive'>(() => {
    if (typeof window !== 'undefined') {
      return document.documentElement.classList.contains('takeover-active') ? 'active' : 'inactive';
    }
    return 'inactive';
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isActive = document.documentElement.classList.contains('takeover-active');
          setStatus(isActive ? 'active' : 'inactive');
        }
      }
    });

    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    return () => {
      observer.disconnect();
    };
  }, []);

  if (status !== props.when) {
    return props.fallback || null;
  }

  return <>{props.children}</>;
};

export default TakeoverStatus;
